<div class="w-full flex justify-center px-10 py-6 shadow-sm flex-wrap gap-2">
  <button class="bg-blue-800 text-white rounded-md p-3 flex items-center mx-4 " (click)="imprimer()"
    [disabled]="!exist">
    <mat-icon>print</mat-icon>Imprimer
  </button>
  <button class="bg-green-600 text-white rounded-md p-3 flex items-center mx-4 " (click)="enregistrer()"
    [disabled]="!exist">
    <mat-icon>save</mat-icon>Enregistrer
  </button>
  <button class="bg-gray-600 text-white rounded-md p-3 flex items-center mx-4 " (click)="vider()" [disabled]="!exist">
    <mat-icon>clear</mat-icon>Vider les champs
  </button>
  <!-- <button (click)="imprimer2()" [disabled]="!exist" mat-raised-button class="colorGreen"><mat-icon>print</mat-icon>Imprimer Declaration</button> -->
</div>

<div class="py-8 px-50 flex flex-col justify-center">
  <ng-container>
    <mat-card class="example-card">
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-card-header>
            <mat-card-title>Accident De Travail</mat-card-title>
          </mat-card-header>
        </div>
        <mat-card-content class="border">
          <!-- <mat-card>
            <mat-card-content>
              <div class="flex justify-center">
                <img src="assets/cnamLogo.png" alt="" class="w-2/6" />
              </div>
            </mat-card-content>
          </mat-card> -->
          <mat-card class="main-card">
            <mat-card>
              <mat-card-title>Employeur</mat-card-title>
              <mat-card-content fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="center" *ngIf="ListSoc">
                  <mat-form-field appearance="legacy">
                    <mat-label>Choisir une Societé</mat-label>
                    <mat-select (selectionChange)="selectSoc($event.value)" [(ngModel)]="societ">
                      <mat-option *ngFor="let soc of ListSoc" [value]="soc.SOC_RS">{{soc.SOC_RS}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none" hidden="true">
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>N° CNSS</mat-label>
                    <input matInput type="text" [(ngModel)]="nCnss">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Raison Social :</mat-label>
                    <input matInput type="text" [(ngModel)]="RS">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Adresse</mat-label>
                    <input matInput type="text" [(ngModel)]="adresse">
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Code Postal</mat-label>
                    <input matInput type="text" [(ngModel)]="codepostal">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label> N° Téléphone</mat-label>
                    <input matInput type="text" [(ngModel)]="nTel">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Nature de l'cativité</mat-label>
                    <input matInput type="text" [(ngModel)]="NatActivite">
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card>
              <mat-card-title>VICTIME</mat-card-title>
              <mat-card-content fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="center ">
                  <app-recherche [style]="{ width: '130px', 'margin-right': '10px' }" [api]="api"
                    [(ngModel)]="persoRech" [numColonneToShow]="1" [numColonneToReturn]="0"
                    (ChampEnter)="blurPerso($event)" recherche="API_PersoCnam2" name="PERSO" [param]="lastIdSoc"
                    placeholder="Perso">
                  </app-recherche>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="20">
                    <mat-label>Numero Affectation C.N.S.S</mat-label>
                    <input matInput type="text" [(ngModel)]="NumAffec">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Nom et Prénom</mat-label>
                    <input matInput type="text" [(ngModel)]="NpVic">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Prénom du pére :</mat-label>
                    <input matInput type="text" [(ngModel)]="PrPere">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Nom de jeune fille</mat-label>
                    <input matInput type="text" [(ngModel)]="njFille">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Nationalité</mat-label>
                    <input matInput type="text" [(ngModel)]="nat">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Sexe</mat-label>
                    <mat-select (selectionChange)="selectSexe($event.value)" [(ngModel)]="Sexe">
                      <mat-option value="H">Homme</mat-option>
                      <mat-option value="F">Femme</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <!-- <mat-form-field appearance="legacy" fxFlex="12" >
                      <mat-label>Date de naissance</mat-label>
                      <div fxFlex="3"></div>
                      <input matInput [matDatepicker]="pickerDateNais" [(ngModel)]="dateNais" (dateChange)="dateChange()">
                      <mat-datepicker-toggle matSuffix [for]="pickerDateNais"></mat-datepicker-toggle>
                      <mat-datepicker #pickerDateNais ></mat-datepicker>
                    </mat-form-field> -->
                  <mat-form-field appearance="legacy" fxFlex="19">
                    <mat-label>Date de Naissance </mat-label>
                    <input matInput [matDatepicker]="pickerDateNais" [(ngModel)]="dateNais"
                      (dateChange)="dateNaisChange()">
                    <mat-datepicker-toggle matSuffix [for]="pickerDateNais"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDateNais></mat-datepicker>
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label> Lieu de Naissance</mat-label>
                    <input matInput type="text" [(ngModel)]="LieuNai">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>N° C.I.N </mat-label>
                    <input matInput type="text" [(ngModel)]="cin">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field>
                    <mat-label>Adresse du domicille</mat-label>
                    <div fxFlex="3"></div>
                    <input matInput type="text" [(ngModel)]="adresseDom">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <!-- <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
              <mat-label>Code Postal</mat-label>
              <input matInput type="text" [(ngModel)]="CodePostal">
            </mat-form-field> -->
                </div>

                <div fxLayout="row" fxLayoutAlign="start none">
                  <!-- <mat-form-field appearance="legacy" fxFlex="12">
                      <mat-label>Date :</mat-label>
                      <input matInput [matDatepicker]="pickerDateEmb" [(ngModel)]="dateEmb">
                      <mat-datepicker-toggle matSuffix [for]="pickerDateEmb"></mat-datepicker-toggle>
                      <mat-datepicker #pickerDateEmb></mat-datepicker>
                    </mat-form-field> -->
                  <mat-form-field appearance="legacy" fxFlex="19">
                    <mat-label>Date d'Embauche </mat-label>
                    <input matInput [matDatepicker]="pickerDateEmb" [(ngModel)]="dateEmb"
                      (dateChange)="dateEmbChange()">
                    <mat-datepicker-toggle matSuffix [for]="pickerDateEmb"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDateEmb></mat-datepicker>
                  </mat-form-field>

                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="20">
                    <mat-label>Qualification Professionnelle</mat-label>
                    <input matInput type="text" [(ngModel)]="qualifPro">
                  </mat-form-field>

                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Status</mat-label>
                    <input matInput type="text" [(ngModel)]="Status">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                    <mat-label>Emploi Habituel</mat-label>
                    <input matInput type="text" [(ngModel)]="EmpHabit">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field appearance="legacy" fxFlex="19">
                    <mat-label>Depuis </mat-label>
                    <input matInput [matDatepicker]="pickerdepuis" [(ngModel)]="depuis" (dateChange)="depuisChange()">
                    <mat-datepicker-toggle matSuffix [for]="pickerdepuis"></mat-datepicker-toggle>
                    <mat-datepicker #pickerdepuis></mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="19">
                    <mat-label>Occupation</mat-label>
                    <input matInput type="text" [(ngModel)]="ocupation">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field appearance="legacy" fxFlex="19">
                    <mat-label>Depuis </mat-label>
                    <input matInput [matDatepicker]="pickerdepuis2" [(ngModel)]="depuis2"
                      (dateChange)="depuis2Change()">
                    <mat-datepicker-toggle matSuffix [for]="pickerdepuis2"></mat-datepicker-toggle>
                    <mat-datepicker #pickerdepuis2></mat-datepicker>
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="20">
                    <mat-label>Adresse du lieu de travail habituel</mat-label>
                    <input matInput type="text" [(ngModel)]="adrHabTrav">
                  </mat-form-field>
                </div>
                <div>
                  <span fxLayoutAlign="space-between center">L'accident a-t-il-fait d'autres victimes </span>
                  <div fxFlex="3"></div>
                  <mat-radio-group fxLayoutAlign="space-between center" [(ngModel)]="autreVictime"
                    (change)="selectAuv($event)">
                    <mat-radio-button value="1">Oui </mat-radio-button>
                    <mat-radio-button value="0">Non </mat-radio-button>
                  </mat-radio-group>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card>
              <mat-card-title>ACCIDENT</mat-card-title>
              <div fxLayout="row" fxLayoutAlign="start none" class="flex flex-row">
                <span fxLayoutAlign="space-between center">Date et heure de l'accident </span>
                <div fxFlex="3"></div>
                <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date </mat-label>
                  <input matInput [matDatepicker]="pickerDateAcc" [(ngModel)]="dateAcc" (dateChange)="dateAccid()">
                  <mat-datepicker-toggle matSuffix [for]="pickerDateAcc"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDateAcc></mat-datepicker>
                </mat-form-field>
                <div fxFlex="3"></div>
                <mat-form-field appearance="legacy" fxFlex="12">
                  <input matInput type="time" [(ngModel)]="time">
                </mat-form-field>
              </div>
              <mat-card-content fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="start none">
                  <span fxLayoutAlign="space-between center">Horaire du travail de la victime lejour de l'accident
                    de</span>
                  <div fxFlex="3"></div>
                  <mat-form-field appearance="legacy" fxFlex="12">
                    <input matInput type="time" [(ngModel)]="timedeb">
                  </mat-form-field>
                  <span fxLayoutAlign="space-between center" style="position:relative;right:6px;">à</span>
                  <mat-form-field appearance="legacy" fxFlex="12">
                    <input matInput type="time" [(ngModel)]="timefin">
                  </mat-form-field>
                  <span fxLayoutAlign="space-between center" style="position:relative;right:6px;">et de </span>
                  <mat-form-field appearance="legacy" fxFlex="12">
                    <input matInput type="time" [(ngModel)]="timePauseDeb">
                  </mat-form-field>
                  <span fxLayoutAlign="space-between center" sstyle="position:relative;right:6px;">à </span>
                  <mat-form-field appearance="legacy" fxFlex="12">
                    <input matInput type="time" [(ngModel)]="timePauseFin">
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="20">
                    <mat-label> Lieu de l'accident</mat-label>
                    <textarea matInput rows="1" [(ngModel)]="lieuAcc"></textarea>
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <span fxLayoutAlign="space-between center">Etablissment ou s'est produit l'accident</span>
                  <div fxFlex="2"></div>
                  <mat-radio-group (change)="handleChange($event)" [(ngModel)]="ouAcci"
                    fxLayoutAlign="space-between center">
                    <mat-radio-button value="Chantier">Chantier </mat-radio-button>
                    <mat-radio-button value="Attelier">Attelier </mat-radio-button>
                    <mat-radio-button value="Bureau">Bureau </mat-radio-button>
                    <mat-radio-button value="Autre">Autre </mat-radio-button>
                  </mat-radio-group>
                  <mat-form-field *ngIf="isAutre" id="example-full-width" appearance="legacy">
                    <mat-label>Presicer</mat-label>
                    <input matInput type="text" [(ngModel)]="autre">
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="15">
                    <mat-label>Nombre Des Employés au moment de l'accident </mat-label>
                    <input matInput type="number" [(ngModel)]="nbemp">
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="30">
                    <mat-label> Circonstance détaillées de l'accident</mat-label>
                    <textarea matInput rows="1" [(ngModel)]="detaillAcc"></textarea>
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Agent Materiél</mat-label>
                    <input matInput type="text" [(ngModel)]="agentMateriel">
                  </mat-form-field>
                  <div fxFlex="2"></div>
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Forme Accident</mat-label>
                    <input matInput type="text" [(ngModel)]="formeAcciden">
                  </mat-form-field>
                  <div fxFlex="2"></div>
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Siége de la lésion</mat-label>
                    <input matInput type="text" [(ngModel)]="siegeLes">
                  </mat-form-field>
                  <div fxFlex="2"></div>
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Nature de la lésion</mat-label>
                    <input matInput type="text" [(ngModel)]="natureLes">
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Lieu ou a été transporté</mat-label>
                    <input matInput type="text" [(ngModel)]="lieuTransp">
                  </mat-form-field>
                  <div fxFlex="2"></div>
                  <mat-form-field appearance="legacy" fxFlex="10">
                    <mat-label>A quelle heure</mat-label>
                    <input matInput type="time" [(ngModel)]="heureTrans">
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-radio-group (selectionChange)="selectConsequence($event)" [(ngModel)]="arretSit">
                    <mat-radio-button value="Consequence">Conséquence </mat-radio-button>
                    <mat-radio-button value="SansArret">Sans Arret de Travail </mat-radio-button>
                    <mat-radio-button value="AvecArret">Avec Arret de Travail </mat-radio-button>
                    <mat-radio-button value="Deces">Deces </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <span fxLayoutAlign="space-between center">Date et heure de l'arret de travail </span>
                  <div fxFlex="3"></div>
                  <mat-form-field appearance="legacy" fxFlex="12">
                    <mat-label>Date Arret</mat-label>
                    <input matInput [matDatepicker]="pickerDateArr" [(ngModel)]="dateArret"
                      (dateChange)="dateAreetTrav()">
                    <mat-datepicker-toggle matSuffix [for]="pickerDateArr"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDateArr></mat-datepicker>
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field appearance="legacy" fxFlex="12">
                    <input matInput type="time" [(ngModel)]="heureArret">
                  </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <span fxLayoutAlign="space-between center">Aprés l'accident le salaire est il mantenu ? </span>
                  <div fxFlex="2"></div>
                  <mat-radio-group fxLayoutAlign="space-between center" [(ngModel)]="salMaint"
                    (selectionChange)="selectsalaire($event)">
                    <mat-radio-button value="1"> Oui </mat-radio-button>
                    <mat-radio-button value="0"> Non </mat-radio-button>
                  </mat-radio-group>
                  <div fxFlex="2"></div>
                  <mat-form-field *ngIf="salMaint=='1'" id="example-full-width" appearance="legacy">
                    <mat-label>Salaire maintenu</mat-label>
                    <input matInput type="text" [(ngModel)]="salaireMAintenu">
                  </mat-form-field>
                </div>
                <div *ngIf="salMaint=='1'" fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Monatnt</mat-label>
                    <input matInput type="text" [(ngModel)]="montant">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Par</mat-label>
                    <input matInput type="text" [(ngModel)]="par">
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card>
              <mat-card-title>TEMOINS</mat-card-title>
              <mat-card-content fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="20">
                    <mat-label> Nom Prenom et Adresse</mat-label>
                    <textarea matInput rows="1" [(ngModel)]="npa"></textarea>
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy" fxFlex="20">
                    <mat-label> Dressé un PV par la police? Numéro</mat-label>
                    <input matInput type="number" [(ngModel)]="pv">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field appearance="legacy" fxFlex="12">
                    <mat-label>Date </mat-label>
                    <input matInput [matDatepicker]="pickerDateTiers" [(ngModel)]="dateTiers"
                      (dateChange)="dateTemoinChange()">
                    <mat-datepicker-toggle matSuffix [for]="pickerDateTiers"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDateTiers></mat-datepicker>
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Poste</mat-label>
                    <input matInput type="text" [(ngModel)]="poste">
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card>
              <mat-card-title>TIERS</mat-card-title>
              <mat-card-content fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="start none">
                  <span>L'accident a-t-il été causé par un tiers? :</span>
                  <div fxFlex="3"></div>
                  <div>
                    <mat-radio-group [(ngModel)]="Tiers" (selectionChange)="selectTiers($event)">
                      <mat-radio-button value="1">Oui </mat-radio-button>
                      <mat-radio-button value="0">Non </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div *ngIf="Tiers=='1'" fxLayout="row" fxLayoutAlign="start none">
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Nom et Prénom </mat-label>
                    <input matInput type="text" [(ngModel)]="npTiers">
                  </mat-form-field>
                  <div fxFlex="3"></div>
                  <mat-form-field id="example-full-width" appearance="legacy">
                    <mat-label>Societé</mat-label>
                    <input matInput type="text" [(ngModel)]="societe">
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-card>
        </mat-card-content>
        <mat-card-footer fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="start none">
            <div fxFlex="2"></div>
            <span fxLayoutAlign="space-between center">Je soussigné (nom et prénoms) :</span>

            <!-- <mat-form-field id="example-full-width" appearance="legacy">
              <mat-label>Nom & Prénom</mat-label>
              <input matInput type="text" [(ngModel)]="nompSous">
            </mat-form-field>
            <div fxFlex="3"></div>
            <span fxLayoutAlign="space-between center">Déclare sur l’honneur, en ma qualité :</span>
            <div fxFlex="3"></div>
            <mat-form-field id="example-full-width" appearance="legacy">
              <mat-label>Fonction</mat-label>
              <input matInput type="text" [(ngModel)]="postSous">
            </mat-form-field> -->
            <app-recherche [style]="{ width: '130px', 'margin-right': '10px' }" [api]="api" [(ngModel)]="persoSousRech"
              [numColonneToShow]="1" [numColonneToReturn]="0" (ChampEnter)="blurPersoSS($event)"
              recherche="API_PersoCnamSig" [param]="lastIdSoc" placeholder="Nom & Prénom">
            </app-recherche>
            <div fxFlex="3"></div>
            <div fxFlex="2"></div> <span fxLayoutAlign="space-between center"> Fait à :</span>
            <div fxFlex="3"></div>
            <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
              <mat-label>Fait à</mat-label>
              <input matInput type="text" [(ngModel)]="faitA">
            </mat-form-field>
            <span fxLayoutAlign="space-between center"> le :</span>
            <div fxFlex="3"></div>
            <mat-form-field appearance="legacy" fxFlex="12">
              <mat-label>Date </mat-label>
              <input matInput [matDatepicker]="pickerDate" [(ngModel)]="le" (dateChange)="dateLe()">
              <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerDate></mat-datepicker>
            </mat-form-field>
          </div>
        </mat-card-footer>
      </mat-card>
    </mat-card>
  </ng-container>
</div>

<div style="display: none;">
  <div id="accident" style="position: relative">
    <div style="background-size: cover;
    width: 794px;height:1115px;position: absolute;" [style]="{top:impTop+'px'}">
      <span style="
                position: absolute;
                top: 202px;
                left: 539px;">
        {{nCnss}}
      </span>


      <span style="
                position: absolute;
                top: 220px;
                left: 195px;">
        {{RS}}
      </span>
      <span style="
                position: absolute;
                top: 237px;
                left: 160px;">
        {{adresse}}

      </span>
      <!-- <span style="
                position: absolute;
                top: 253px;
                left: 57px;">
                            adresse 2
            </span> -->


      <span style="
                position: absolute;
                top: 254px;
                left: 388px;">
        {{codepostal}}
      </span>

      <span style="
                position: absolute;
                top: 254px;
                left: 540px;">
        {{nTel}}

      </span>

      <span style="
                position: absolute;
                top: 270px;
                left: 183px;">
        {{NatActivite}}
      </span>

      <span style="
                position: absolute;
                top: 307px;
                left: 550px;">
        {{NumAffec}}
      </span>

      <span style="
                position: absolute;
                top: 322px;
                left: 140px;">
        {{NpVic}}
      </span>
      <span style="
                position: absolute;
                top: 324px;
                left: 505px;">
        {{PrPere}}
      </span>
      <span style="
                position: absolute;
                top: 350px;
                left: 160px;">
        {{njFille}}
      </span>
      <span style="
                position: absolute;
                top: 343px;
                left: 429px;">
        {{nat}}
      </span>
      <span *ngIf="Sexe=='H'" style="
                position: absolute;
                font-size: 10px;
                top: 345px;
                left: 590px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>

      <span *ngIf="Sexe=='F'" style="
                position: absolute;
                font-size: 10px;
                top: 345px;
                left: 607px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>

      <span style="
                position: absolute;
                top: 363px;
                left: 210px;">
        {{dateNaisSpan}}
      </span>

      <span style="
                position: absolute;
                top: 365px;
                left: 349px;">
        {{LieuNai}}
      </span>
      <span style="
                position: absolute;
                top: 364px;
                left: 542px;">
        {{cin}}
      </span>

      <span style="
                position: absolute;
                top: 382px;
                left: 170px;">
        {{adresseDom}}
      </span>
      <!-- <span style="
                position: absolute;
                top: 398px;
                left: 59px;">
                           adresse domocile 2
           </span> -->

      <span style="
                position: absolute;
                top: 414px;
                left: 185px;">
        {{dateEmbSpan}}
      </span>

      <span style="
                position: absolute;
                top: 416px;
                left: 455px;">
        {{qualifPro}}
      </span>
      <span style="
                position: absolute;
                top: 415px;
                left: 595px;">
        {{Status}}
      </span>
      <span style="
                position: absolute;
                top: 437px;
                left: 173px;">
        {{EmpHabit}}
      </span>
      <span style="
                position: absolute;
                top: 435px;
                left: 490px;">
        {{datedepuis}}
      </span>
      <span style="
                position: absolute;
                top: 453px;
                left: 243px;">
        {{ocupation}}
      </span>
      <span style="
                position: absolute;
                top: 455px;
                left: 492px;">
        {{datedepuis2}}
      </span>

      <span style="
                position: absolute;
                top: 468px;
                left: 228px;">
        {{adrHabTrav}}
      </span>
      <span *ngIf="autreVictime=='1'" style="
                position: absolute;
                top: 485px;
                left: 312px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span *ngIf="autreVictime=='0'" style="
                position: absolute;
                top: 485px;
                left: 393px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>

      <span *ngIf="dateAccidan" style="
                position: absolute;
                top: 519px;
                left: 373px;">
        {{dateAccidan.substring(0,2)}}
      </span>


      <span *ngIf="dateAccidan" style="
                position: absolute;
                top: 519px;
                left: 419px;">
        {{dateAccidan.substring(3,5)}}
      </span>


      <span *ngIf="dateAccidan" style="
                position: absolute;
                top: 519px;
                left: 460px;">
        {{dateAccidan.substring(6,dateAccidan.length)}}
      </span>


      <span *ngIf="time" style="
                position: absolute;
                top: 519px;
                left: 528px;">
        {{time.substring(0,2)}}

      </span>

      <span *ngIf="time" style="
                position: absolute;
                top: 519px;
                left: 574px;">
        {{time.substring(3,5)}}
      </span>
      <span style="
                position: absolute;
                top: 545px;
                left: 344px;">
        {{timedeb}}
      </span>

      <span style="
                position: absolute;
                top: 545px;
                left: 418px;">
        {{timefin}}
      </span>

      <span style="
                position: absolute;
                top: 545px;
                left: 515px;">
        {{timePauseDeb}}
      </span>

      <span style="
                position: absolute;
                top: 545px;
                left: 597px;">
        {{timePauseFin}}
      </span>

      <span style="
                position: absolute;
                top: 562px;
                left: 173px;">
        {{lieuAcc}}
      </span>
      <!-- <span style="
                position: absolute;
                top: 576px;
                left: 57px;">
                           Lieu accident 2
           </span> -->
      <span *ngIf="ouAcci=='Chantier'" style="
                position: absolute;
                top: 590px;
                left: 269px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span *ngIf="ouAcci=='Attelier'" style="
                position: absolute;
                top: 590px;
                left: 344px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span *ngIf="ouAcci=='Bureau'" style="
                position: absolute;
                top: 590px;
                left: 420px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span *ngIf="ouAcci=='Autre'" style="
                position: absolute;
                top: 590px;
                left: 510px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span style="
                position: absolute;
                top: 611px;
                left: 590px;">
        {{autre}}
      </span>
      <span style="
                position: absolute;
                top: 611px;
                left: 420px;">
        {{nbemp}}
      </span>
      <span *ngIf="detaillAcc" style="
                position: absolute;
                top: 623px;
                left: 256px;">
        {{detaillAcc.substring(0,56)}}
      </span>
      <span *ngIf="detaillAcc" style="
                position: absolute;
                top: 639px;
                left: 58px;">
        {{detaillAcc.substring(56,139)}}
      </span>
      <span *ngIf="detaillAcc" style="
                position: absolute;
                top: 656px;
                left: 59px;">
        {{detaillAcc.substring(140,226)}}
      </span>
      <span style="
                position: absolute;
                top: 671px;
                left: 279px;">
        {{agentMateriel}}
      </span>
      <span style="
                position: absolute;
                top: 671px;
                left: 529px;">
        {{formeAcciden}}
      </span>
      <span style="
                position: absolute;
                top: 689px;
                left: 171px;">
        {{siegeLes}}
      </span>
      <span style="
                position: absolute;
                top: 705px;
                left: 182px;">
        {{natureLes}}
      </span>
      <span style="
                position: absolute;
                top: 721px;
                left: 242px;">
        {{lieuTransp}}
      </span>
      <span style="
                position: absolute;
                top: 721px;
                left: 600px;">
        {{heureTrans}}
      </span>
      <span *ngIf="arretSit=='Consequence'" style="
                position: absolute;
                top: 733px;
                left: 154px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span *ngIf="arretSit=='SansArret'" style="
                position: absolute;
                top: 733px;
                left: 365px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span *ngIf="arretSit=='AvecArret'" style="
                position: absolute;
                top: 733px;
                left: 533px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span *ngIf="arretSit=='Deces'" style="
                position: absolute;
                top: 733px;
                left: 641px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>


      <span *ngIf="dateArretTra" style="
                position: absolute;
                top: 768px;
                left: 230px;">
        {{dateArretTra.substring(0,2)}}
      </span>

      <span *ngIf="dateArretTra" style="
                position: absolute;
                top: 768px;
                left: 278px;">
        {{dateArretTra.substring(3,5)}}
      </span>

      <span *ngIf="dateArretTra" style="
                position: absolute;
                top: 768px;
                left: 316px;">
        {{dateArretTra.substring(6,10)}}
      </span>

      <span *ngIf="heureArret" style="
                position: absolute;
                top: 768px;
                left: 380px;">
        {{heureArret.substring(0,2)}}
      </span>

      <span *ngIf="heureArret" style="
                position: absolute;
                top: 768px;
                left: 430px;">
        {{heureArret.substring(3,5)}}
      </span>
      <span *ngIf="salMaint=='1'" style="
                position: absolute;
                top: 791px;
                left: 334px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span *ngIf="salMaint=='0'" style="
                position: absolute;
                top: 791px;
                left: 492px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span style="
                position: absolute;
                top: 818px;
                left: 281px;">
        {{salaireMAintenu}}
      </span>

      <span style="
                position: absolute;
                top: 835px;
                left: 167px;">
        {{montant}}
      </span>

      <span style="
                position: absolute;
                top: 842px;
                left: 370px;">
        {{par}}
      </span>
      <span style="
                position: absolute;
                top: 88px;
                left: 66px;">
        {{npa}}
      </span>
      <!-- <span style="
                position: absolute;
                top: 906px;
                left: 66px;">
        Nom et prénom 2
      </span> -->
      <span style="
                position: absolute;
                top: 913px;
                left: 422px;">
        {{pv}}
      </span>
      <span style="
                position: absolute;
                top: 926px;
                left: 100px;">
        {{dateTemoinSpan}}
      </span>
      <span style="
                position: absolute;
                top: 926px;
                left: 314px;">
        {{poste}}
      </span>
      <span *ngIf="Tiers=='1'" style="
                position: absolute;
                top: 963px;
                left: 358px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span *ngIf="Tiers=='0'" style="
                position: absolute;
                top: 963px;
                left: 515px;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </span>
      <span style="
                position: absolute;
                top: 989px;
                left: 296px;">
        {{npTiers}}
      </span>

      <span style=" 
                position: absolute;
                top: 1007px;
                left: 200px;">
        {{societe}}
      </span>
      <span style="
                position: absolute;
                top: 1023px;
                left: 203px;">
        {{nompSous}}
      </span>
      <span style="
                position: absolute;
                top: 1043px;
                left: 78px;">
        {{postSous}}
      </span>
      <span style="
                position: absolute;
                top: 1061px;
                left: 545px;">
        {{faitA}}
      </span>

      <span style="
                position: absolute;
                top: 1061px;
                left: 652px;">
        {{dateLeSpan}}
      </span>
    </div>
  </div>
